import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DpadZoneDirective } from '../directives/dpad-zone.directive';

@Injectable({
  providedIn: 'root'
})
export class NavManagerService {

  public addZoneBroker = new Subject<DpadZoneDirective>();
  public removeZoneBroker = new Subject<string>();
  public moveZoneBroker = new Subject<string>();

  unassignedSelectables: any;

  constructor() { }

  add(container: DpadZoneDirective) {
    this.addZoneBroker.next(container);
  }

  remove(containerName: string) {
    this.removeZoneBroker.next(containerName);
  }

  moveToZone(zone: string) {
    this.moveZoneBroker.next(zone);
  }
}
